import { TeContainer } from '@topcon/tuicl-react';
import { Component, ReactNode, useRef } from 'react';
import styled from 'styled-components';

interface Props {
  children: ReactNode;
  filesDragStarted: () => void;
  filesDragStopped: () => void;
  filesDropped: (files: File[]) => void;
  filesBeingDragged: boolean;
}

function FileDropContainer({
  children,
  filesDragStarted,
  filesDragStopped,
  filesDropped,
  filesBeingDragged,
}: Props) {
  const backgroundColor = filesBeingDragged ? 'background.selected' : 'background.secondary';
  const dragStack = useRef(0);

  const handleDragEnter = (e: React.DragEvent<Component>) => {
    if (dragStack.current === 0) filesDragStarted();
    // Add +1 to the drag stack every time a element is entered
    dragStack.current += 1;
    e.preventDefault();
  };

  const handleDragLeave = (e: React.DragEvent<Component>) => {
    // Remove -1 from the drag stack every time a element is exited
    dragStack.current -= 1;
    e.preventDefault();
    // If stack reaches 0 it means all of the elements have been exited
    if (dragStack.current === 0) filesDragStopped();
  };

  const handleDrop = (e: React.DragEvent<Component>) => {
    // Reset stack on drop - dropping works as usual
    dragStack.current = 0;
    e.preventDefault();
    const droppedFiles = e.dataTransfer.files;
    if (!droppedFiles[0]) return;
    filesDropped(Array.from(droppedFiles));
  };

  return (
    <UploadContainer
      backgroundColor={backgroundColor}
      borderColor="border.primary"
      borderRadius={4}
      justifyContent="center"
      alignItems="center"
      padding={['xl4', 'l']}
      grow
      column
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onDragOver={(e) => e.preventDefault()}
    >
      {children}
    </UploadContainer>
  );
}

const UploadContainer = styled(TeContainer)`
  width: 100% !important;
  border-style: dashed !important;
`;

export default FileDropContainer;
